<template>
  <div>
    <ProductionOrderView :orderCode="orderCode" />
  </div>
</template>
<script>
import ProductionOrderView from '@/views/factory/components/production-order/order-view'
export default {
  name: 'plan-noticeInspectionOrder-detail',
  components: { ProductionOrderView },
  computed: {
    params() {
      return this.$route.params
    },
    orderCode() {
      return this.params.orderCode
    },
  },
}
</script>
